export default "__VITE_ASSET__DtfXiEyo__"